import React, { useState } from "react";
import { Col } from "reactstrap";
import styled from "styled-components";
import LoginForm from "./LoginForm";
import FullLayout from "../../components/layout/FullLayout";

const Wrapper = styled(Col)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: white;
  min-height: 100vh;
`;

const LoginComponent = () => {
  const [loginMode, setLoginMode] = useState("regular"); // "regular" or "code"

  return (
    <FullLayout>
      <Wrapper
        lg="5"
        xl="4"
      >
        <LoginForm
          loginMode={loginMode}
          setLoginMode={setLoginMode}
        />
      </Wrapper>
    </FullLayout>
  );
};

export default LoginComponent;
